import React from 'react';
import './PremiumTeam.css';
import HourlyCategorySelect from '../../Shared/HourlyCategorySelect/HourlyCategorySelect';

const PremiumTeam = () => {
    const teamOptions = [
        { title: 'Photographer', image: 'img1.png' },
        { title: 'Cinematographer', image: 'img2.png' },
        { title: 'Editing', image: 'img3.png' },
        { title: 'Studio Light', image: 'img4.png' }
    ];

    return (
        <div className="premium-team-section">


            <h2 className="prt-main-title">Build Your Elite Production Team</h2>

            <div className="prt-content-card">
                <div className="prt-text-content">
                    <h3 className="prt-heading">Crafted for grand celebrations and high-impact productions.</h3>
                    <p className="prt-description">
                        Select your duration. Experience refined execution.
                        <br />
                        Every frame captured with intention.
                    </p>
                </div>

                <div className="prt-options-grid">
                    {teamOptions.map((option, index) => (
                        <div key={index} className="prt-option-card">
                            <img
                                src={`/asset/ServicePages/HourlyPages/${option.image}`}
                                alt={option.title}
                                className="prt-option-icon"
                            />
                            <span className="prt-option-label">{option.title}</span>
                        </div>
                    ))}
                </div>
            </div>
            <div className="prt-dropdown-container margin-top">
                <HourlyCategorySelect className="prt-category-dropdown" />
            </div>
        </div>
    );
};

export default PremiumTeam;
